import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { FetchCertificateRecord, FetchCertificateRecordFailure, FetchCertificateRecordSuccess } from 'app/library/certificate-record/actions';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';

@Injectable()
export class CertificateRecordResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const certificateRecordId = route.params['id'];

        this._store.dispatch(new FetchCertificateRecord(certificateRecordId));

        return await this._actionHelper.race(FetchCertificateRecordSuccess, FetchCertificateRecordFailure).toPromise();
    }
}
